import { Menu } from 'ant-design-vue'
import SideMenu from './menu.vue'
import '@/components/l8-icon'
import '../css/menu.less'

/* istanbul ignore next */
SideMenu.install = function (Vue) {
  Vue.component(SideMenu.name, SideMenu)
  Vue.use(Menu)
}

export default SideMenu
